import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    fullPageLoader$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    constructor() {}
}